import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink pb-16" data-id="element-78" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-79" data-mp="3gh3sii3dgcgq">
        <p className="text-xs leading-snug text-paper/60" data-id="element-80" data-mp="32pfci3q053uh">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-xs leading-snug text-paper/60" data-id="element-81" data-mp="36n3dnoiafsut">
          {PRODUCT_NAME} es un producto educativo. No sustituye capacitación
          práctica supervisada, procedimientos de seguridad, manuales de
          fabricantes, normas técnicas ni la evaluación de un profesional
          competente. Los trabajos de corte, soldadura y fabricación deben
          realizarse con equipos de protección adecuados. Los diseños requieren
          verificar cargas, materiales, uniones y estabilidad antes de su uso.
        </p>
        <p className="mt-1.5 text-xs text-paper/80" data-id="element-82" data-mp="2eyt94pqy07qt">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-83" data-mp="3l9k6jf1oprec">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-paper/80" data-id="element-84" data-mp="3v7zw3dl2cslq">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-85" data-mp="82qsbsqetttq">
            Términos y Condiciones
          </a>
          <span className="text-paper/40" data-id="element-86" data-mp="3231p863ff01">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-87" data-mp="hrs7xht1m976">
            Política de Privacidad
          </a>
          <span className="text-paper/40" data-id="element-88" data-mp="qsqdi4j4qorv">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-89" data-mp="qrfai6xidl1t">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}